import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  deleteAgentAction,
  listAgentsAction,
} from '../../../../store/actions/agents.action';
import { showToastError } from 'src/utilities/errortoast';

const DeleteAgent = ({ isOpen, setIsOpen, filterValue, agentId, orgUuid }) => {
  const dispatch = useDispatch();
  const { agentsItem } = useSelector((state) => state?.agentsState);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleDelete = async () => {
    if (!orgUuid) {
      showToastError('Organization UUID is required');
      return;
    }

    if (agentsItem || agentId) {
      dispatch(
        deleteAgentAction(orgUuid, agentId, () => {
          handleClose();
          dispatch(listAgentsAction(orgUuid, filterValue));
        })
      );
    }
  };

  return (
    <Modal
      title="Delete Agent"
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      width={400}
    >
      <div className="flex flex-col items-center py-4">
        <ExclamationCircleOutlined
          style={{ fontSize: '48px', color: '#ff4d4f', marginBottom: '16px' }}
        />
        <h3 className="text-lg font-medium mb-2">Confirm Deletion</h3>
        <p className="text-center mb-6">
          Are you sure you want to delete this agent? This action cannot be
          undone and may affect any dependent services.
        </p>
        <div className="flex justify-end w-full">
          <Button onClick={handleClose} className="mr-2">
            Cancel
          </Button>
          <Button
            type="primary"
            danger
            onClick={handleDelete}
            disabled={!orgUuid}
          >
            Delete Agent
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteAgent;
